var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scroll-wrap"},[(_vm.noMore)?_c('div',{staticClass:"notMore"},[_vm._v("没有更多了")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }